import type { FC } from "react";
import type { GridCard } from "widgets";
import { Card } from "widgets";

import { TagManagement, type TagManagementProps } from "@/modules/projects/components/TagManagement";

interface TagManagementCardProps extends GridCard, TagManagementProps {}

export const TagManagementCard: FC<TagManagementCardProps> = (props) => {
  return (
    <Card title={"Tags"}>
      <TagManagement projectId={props.projectId} />
    </Card>
  );
};
